import { useTranslation } from '@jupiter/plugin-runtime/i18n';
import { useEffect } from 'react';
import { useModuleLandingPageModel } from '@/containers/module-landing/models/ModuleLandingPage.Model';

export const useModuleLanding = () => {
  const { i18n } = useTranslation();
  const {
    loading,
    err,
    empty,
    errorText,
    hotModuleData,
    exploreData,
    fetchAll,
  } = useModuleLandingPageModel();

  useEffect(() => {
    fetchAll();
  }, [i18n.language]);

  return {
    loading,
    err,
    empty,
    errorText,
    hotModuleData,
    exploreData,
  };
};
